import { IApplicationState } from '../../types/redux';

export const selectMarkedListSchema = (state: IApplicationState): string | undefined => {
  return state.seo.markedList?.schema || undefined;
};
